import { render } from "./reloadPage.vue?vue&type=template&id=43c1c1da"
import script from "./reloadPage.vue?vue&type=script&lang=js"
export * from "./reloadPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__